export const onGetUserMetricsByLocation = (users, locations, period) => {
    //console.log(users)
    //console.log(locations)
    console.log(period)

    let result = []
    let result_metrics = []
    /*for (let index = 0; index < locations.length; index++) {
        const element = locations[index];
        let count =  0
        //console.log(`Sitio ${element?.name}`)
        const filtered_users = users.filter(el => el.client_location_id === element.id_client_location)
        //const aux = users.filter(el => el)
        //console.log("Usuarios totales->", filtered_users.length)
        let total_appointments = 0
        let double_appointments = 0
        filtered_users.forEach(el => {
            total_appointments += el?.appointments_in_period?.length ?? 0
            if(el?.appointments_in_period?.length > 1) double_appointments++

        });

        
        //console.log("Appointments totales->", total_appointments)
        result.push({
            name:element?.name,
            total_users:filtered_users.length,
            total_appointments:total_appointments,
            double_appointments:double_appointments
        })


    }

    let count =  0
    //console.log(`Sitio sin definir`)
    const filtered_users = users.filter(el => el.client_location_id === null)
    //const aux = users.filter(el => el)
    //console.log("Usuarios totales->", filtered_users.length)

    let total_appointments = 0
    let double_appointments = 0

    filtered_users.forEach(element => {
        total_appointments += element?.appointments_in_period?.length ?? 0
        if(element?.appointments_in_period?.length > 1) double_appointments++

    });
    //console.log("Appointments totales->", total_appointments)
    result.push({
        name:"Sin sitio",
        total_users:filtered_users.length,
        total_appointments:total_appointments,
        double_appointments:double_appointments

    })
    let final_appointments = 0
    let double_appointments_plus = 0
    result.forEach(item => {
        final_appointments += item.total_appointments
        double_appointments_plus += item.double_appointments
        console.log(`${item.name},${item.total_users},${item.total_appointments},${item.double_appointments}`)
    })
    console.log("Appointment totales: ", final_appointments)
    console.log("Appointment dobles: ", double_appointments_plus)

    console.log(result)
*/
    let imc = 0
    let imc_female = 0
    let imc_male = 0
    let weight = 0
    let fat_mass = 0
    let lean_mass = 0
    let circumference_waist = 0 //cintura
    let circumference_hips = 0 //cadera
    let icc_female = 0
    let icc_male = 0
    
    let imc_count = 0
    let imc_female_count = 0
    let imc_male_count = 0
    let weight_count = 0
    let fat_mass_count = 0
    let lean_mass_count = 0
    let circumference_waist_count = 0 //cintura
    let circumference_hips_count = 0 //cadera
    let icc_female_count = 0
    let icc_male_count = 0

    let green=0
    let yellow=0
    let red=0

    let appointmentscount = 0
    let notappoitmentdetected = 0

    for (let index = 0; index < users.length; index++) {
        const element = users[index];


        let current_appointment = null
        if(element?.appointments_in_period.length>0){
            current_appointment = element?.appointments_in_period[0]
        }
        if(!current_appointment){
            if(element?.appointments_before_period?.length){
                current_appointment = element?.appointments_before_period[element?.appointments_before_period?.length-1]
            }
        }
        if(!current_appointment){
            //console.log("No se detectó nada")
            //console.log(element)
            notappoitmentdetected++
        }

        if(current_appointment){
            appointmentscount++
            const current_appointment = element?.appointments_in_period[0]
            let imc_value = Number(current_appointment?.imc ?? 0)
            let weight_value = Number(current_appointment?.weight ?? 0)
            let fat_mass_value = Number(current_appointment?.fat_mass ?? 0)
            let lean_mass_value = Number(current_appointment?.lean_mass ?? 0)
            let circumference_waist_value = Number(current_appointment?.circumference_waist ?? 0)
            let circumference_hips_value = Number(current_appointment?.circumference_hips ?? 0)
            let icc_value = Number(current_appointment?.icc ?? 0)

            if(current_appointment?.risk_level_id === 1) green++
            if(current_appointment?.risk_level_id === 2) yellow++
            if(current_appointment?.risk_level_id === 3) red++ 

            if(imc_value > 0){
                imc += imc_value
                imc_count++
                if(element?.gender_id === 1){
                    imc_male +=imc_value
                    imc_male_count++
                }
                if(element?.gender_id === 2){
                    imc_female +=imc_value
                    imc_female_count++
                }
            }
            if(weight_value > 0){
                weight += weight_value
                weight_count++
            }
            if(fat_mass_value > 0){
                fat_mass += fat_mass_value
                fat_mass_count++
            }
            if(lean_mass_value > 0){
                lean_mass += lean_mass_value
                lean_mass_count++
            }
            if(circumference_waist_value > 0){
                circumference_waist += circumference_waist_value
                circumference_waist_count++
            }
            
            if(circumference_hips_value > 0){
                circumference_hips += circumference_hips_value
                circumference_hips_count++
            }
            if(icc_value > 0){
                if(element?.gender_id === 1){
                    icc_male +=icc_value
                    icc_male_count++
                }
                if(element?.gender_id === 2){
                    icc_female +=icc_value
                    icc_female_count++
                }
            }

        }

        


        
    }
    console.log("Total users", users.length)
    console.log("usuarios sin consutla detectada", notappoitmentdetected)
    let data = [
        appointmentscount,
        imc/imc_count, 
        imc_male/(imc_male_count > 0 ? imc_male_count : 1), 
        imc_female/(imc_female_count > 0 ? imc_female_count : 1),
        weight,
        fat_mass,
        lean_mass,
        green,
        yellow,
        red,
        circumference_waist,
        circumference_hips,
        icc_male/(icc_male_count > 0 ? icc_male_count : 1),
        icc_female/(icc_female_count > 0 ? icc_female_count : 1),
    ]

    console.log(
        data.join(',')
    )


}